import {DeviceService} from "../../Services/DeviceService";

export const ClockDirective = [
  '$interval', 'dateFilter', 'device',
  ($interval: ng.IIntervalService, dateFilter, device: DeviceService) => {
    return (scope, element, attrs) => {
      var timeoutId;

      function update() {
        element.html(dateFilter(new Date(), 'dd.MM.yyyy') + (device.isTablet() ? '<br/>' : ', ') + dateFilter(new Date(), 'HH:mm'));
      }

      function start() {
        timeoutId = $interval(() => update(), 1000)
      }

      element.bind('$destroy', () => {
        $interval.cancel(timeoutId);
      });

      update();
      start();
    }
  }];